// src/PauseCircleIcon.tsx
import { jsx } from "react/jsx-runtime";
var PauseCircleIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M8.74511 17.5645C4.05283 17.5593 0.25027 13.7567 0.245117 9.06446V8.89446C0.338559 4.22332 4.18451 0.503231 8.85618 0.565217C13.5278 0.627202 17.2737 4.44802 17.2432 9.12C17.2127 13.792 13.4172 17.5635 8.74511 17.5645ZM8.73151 15.8645H8.74511C12.4993 15.8607 15.5402 12.8153 15.5383 9.06106C15.5364 5.30686 12.4925 2.26447 8.73831 2.26447C4.9841 2.26447 1.94019 5.30686 1.93832 9.06106C1.93644 12.8153 4.97731 15.8607 8.73151 15.8645ZM11.2951 12.4645H9.59511V5.66446H11.2951V12.4645ZM7.89511 12.4645H6.19511V5.66446H7.89511V12.4645Z" })
  }
);

export {
  PauseCircleIcon
};
